import 'lazysizes';
import 'js/plugin/jquery-featured-post/featured-post.jquery';
import 'js/plugin/stick.jquery';
/* import 'js/plugin/anti-adblock.js'; */
import 'js/desktop/common/main-nav.jquery';

/**
 * Stick the main nav
 */
$('.main-nav__container').stick();

/**
 * Load featured post
 */
$('#featured-now').featuredPost();

/**
 * Load featured magazine
 */
//$('#featured-magazine').featuredMagazine();

/**
 * Stick content on the default sidebar
 */
$(document).on('featuredPost:loaded', function () {
  $('.default-sidebar__stick').stick({
    offset: 36,
    watch: [$('.default-sidebar__static')]
  });
});

/**
 * Hired banners and Search Box are loaded asyncronously
 * because they aren't critial
 */
require([
  'js/plugin/search-box.jquery.js',
  'js/plugin/random-banner.jquery.js'
], function () {
    $('.random-banner').randomBanner();

    /**
     * A nice animated search box.
     */
    $('.search-switch').searchBox();
  }
);

$.getScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js', function () {
  require(['js/plugin/one-signal.js'], function () {
    $('#one-signal__sdk-config').onesignal();
  });
});

/**
 * Load exit screen if there's no Cookie
 * stored in the browser
 */
// require(['js/desktop/common/jquery-exit-screen/exit-screen.jquery.js']);
